import { render, staticRenderFns } from "./SampleResultNoise.vue?vue&type=template&id=b8c30504&scoped=true"
import script from "./SampleResultNoise.vue?vue&type=script&lang=js"
export * from "./SampleResultNoise.vue?vue&type=script&lang=js"
import style0 from "./SampleResultNoise.vue?vue&type=style&index=0&id=b8c30504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c30504",
  null
  
)

export default component.exports